export let lang = {
  'id': 'de',
  // Errors
  'errorBaseConfigurationNotLoaded': 'Konnte Basis-Konfiguration nicht laden',
  'errorExhibitionSpecificConfiguration': 'Konnte messespezifische Konfiguration nicht laden',
  'errorNoBoothId': 'Keine Stand-ID angegeben',
  'errorNoBoothForBoothId': 'Es konnte kein zur Stand-ID zugehöriger Stand gefunden werden',
  'errorNoValidConfiguration': 'Keine gültige Konfiguration für die gewählte Messe gefunden',
  'errorGivenExhibitionIdNotFound': 'Konnte die angegebene Messe-ID nicht finden',
  'errorNoExhibitionIdsInConfig': 'Die Konfiguration beinhaltet keine Messe-IDs',
  'errorInitFailedNoValidExhibitionId': 'Kann Karte nicht initialisieren. Keine gültige Messe ID gefunden',
  'errorInvalidHash': 'Der angegebene Hash-Wert ist ungültig',
  'errorTitle': 'Flayr Fehler',
  'errorUnknownSource': 'ist eine unbekannte Source',
  'errorUnknownLayerFormat': 'ist ein unbekanntes Layerformat',
  'errorUnknownSourceTypeForLayers': 'ist ein unbekannter Quellentyp für Layer',
  'errorUnknownLayerType': 'ist ein unbekannter Layertyp',
  'errorUnknownSourceType': 'ist ein unbekannter Quellentyp',
  // Buttons
  'buttonBackToBooth': 'Zurück zum Stand',
  'buttonAlternativePlacementProposal': 'Alternativer Platzierungsvorschlag:',
  'buttonPrintHallPlan': 'Hallenplan drucken',
  // Navigator
  'navigatorYouAreHere': 'Sie sind hier: ',
  'navigatorPlaceholder': 'Messegelände',
  // Side navigation / Attribution
  'sideNavigationImprint': 'Impressum',
  'sideNavigationDataPrivacy': 'Datenschutz',
  'sideNavigationTermsAndConditions': 'Allgemeine Geschäftsbedingungen',
  'sideNavigationHelp': 'Hilfe',
  // Print
  'printPoweredBy': 'Unterstützt von Flayr',
  'printPrintHeader': 'Standplatzierungsvorschlag',
  'printDateTime': 'vom {DATE}, {HOUR}:{MINUTE} Uhr',
  'printProposedBooth': 'Vorgeschlagener Stand:',
  'printExhibitorName': 'Ausstellername:',
  'printBillingAddress': 'Rechnungsadresse:',
  'printExhibitorType': 'Ausstellertyp:',
  'printOtherExhibitors': 'Andere Aussteller am Stand:',
  // Context
  'contextOverview': 'Übersicht',
  'contextBooth': 'Stand',
  'contextLoadingData': 'Lade Daten',
  'contextExhibitor': 'Aussteller',
  'contextExhibitorIcon': 'fa-user',
  'contextCoexhibitor': 'Mitaussteller',
  'contextCoexhibitorIcon': 'fa-user',
  'contextJointExhibitor': 'Gemeinschaftsaussteller',
  'contextJointExhibitorIcon': 'fa-users',
  'contextJointOrganiser': 'Mitorganisator',
  'contextJointOrganiserIcon': 'fa-users',
  'contextBoothDimensions': 'Standbemaßung',
  'contextBoothWidth': 'Breite:',
  'contextBoothDepth': 'Tiefe:',
  'contextBoothArea': 'Fläche:',
  'contextMoreDetails': 'Weitere Details zu',
  'contextMoreDetailsLinkTitle': 'Klicken Sie hier, um mehr über {FEATURE} zu erfahren',
  // JSON
  'jsonHall': 'Halle',
  'OUTDOORSPACE': 'Freigelände',
  'YARD': 'Hof',
  'jsonEntry': 'Eingang',
  'ICM': 'ICM',
  'ATRIUM': 'Atrium',
  'GATE': 'Tor',
  'MENSWC': 'WC Herren',
  'LADIESWC': 'WC Damen',
  'DISABLEDPWC': 'Behinderten-WC',
  'BISTRO': 'Bistro',
  'RESTAURANTKAEFER': 'Restaurant "Käfer am See" im Obergeschoss',
  'KAEFERDAYBAR': 'Käfer Tagesbar',
  'INFOBOOTH': 'Info-Stand',
  'ROLLUPDOOR': 'Rolltor',
  'PRCARPARK': 'P + R Parkhaus',
  'NORTH': 'Nord',
  'NORTHEG': 'Nord EG',
  'NORTHOG': 'Nord OG',
  'EAST': 'Ost',
  'EASTEG': 'Ost EG',
  'EASTOG': 'Ost OG',
  'WEST': 'West',
  'WESTEG': 'West EG',
  'WESTOG': 'West OG',
  'CHANNEL': 'Tunnel',
  'CHANNELEAST': 'Tunnel Ost',
  'CONFERENCEROOM': 'Konferenzraum',
  'FOYER': 'Foyer',
  'ICMBUSINESSCENTER': 'ICM Business Center',
  'SALOON': 'Saal',
  'GASTRONOMYCATERING': 'Gastronomie / Catering',
  'TICKETS': 'Kassen',
  'AMBULANCE': 'Ambulanz',
  'SNACKBAR': 'Imbiss',
  'CCN': 'CCN',
  'PIZZASERVICEMARCO': '(Pizza-)Service Marco',
  // Tooltip
  'tooltipBooth': 'Stand',
  // Modules
  'rotateControlNorthRotationTitle': 'Nach Norden ausrichten',
  'rotateControlRotateLeftTitle': 'Nach links drehen',
  'rotateControlRotateRightTitle': 'Nach rechts drehen',
  'rotateControlResetRotationTitle': 'Zur Ausgangsrotation zurückkehren',
  'sideNavigationDefaultTitle': 'Hauptmenü',
  'SOLD': 'VERKAUFT',
  'FREE': 'VERFÜGBAR',
  'HALLSOLDOUT': 'AUSVERKAUFT',
};
